import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=6b918740"
import script from "./modal.js?vue&type=script&lang=js&external"
export * from "./modal.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports